/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Camera_Live_ErrorInputs */

const vi_vehicle_camera_live_error = /** @type {(inputs: Vehicle_Camera_Live_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể mở live camera`)
};

/**

* @param {Vehicle_Camera_Live_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_camera_live_error = /** @type {((inputs?: Vehicle_Camera_Live_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Camera_Live_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_camera_live_error(inputs)
});